const normalizeIdentifier = value => String(value || '').trim()
const UK_POSTCODE_PATTERN = /\b[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}\b/i

const extractPostcode = value => {
  const match = String(value || '').match(UK_POSTCODE_PATTERN)

  return match ? match[0].trim().toUpperCase() : ''
}

export const selectBpMapPostcode = (storedPostcode, passportName) =>
  extractPostcode(passportName) || extractPostcode(storedPostcode)

export const collectCandidateUprns = candidates =>
  Array.from(
    new Set(
      (candidates || [])
        .flatMap(candidate => [
          candidate?.uprn,
          ...(Array.isArray(candidate?.uprns) ? candidate.uprns : [])
        ])
        .map(normalizeIdentifier)
        .filter(Boolean)
    )
  )

export const preferPopulatedList = (primary, fallback = []) =>
  Array.isArray(primary) && primary.length ? primary : fallback

export const selectPostcoderFocusCandidates = (candidates, referenceUprn) => {
  const allCandidates = Array.isArray(candidates) ? candidates : []
  const normalizedReferenceUprn = normalizeIdentifier(referenceUprn)

  if (!normalizedReferenceUprn) {
    return allCandidates
  }

  const referenceCandidates = allCandidates.filter(candidate =>
    collectCandidateUprns([candidate]).includes(normalizedReferenceUprn)
  )

  // Some legacy passports have an obsolete or incomplete UPRN. In that case
  // keep the postcode-level behaviour instead of leaving the map without a
  // usable focus point.
  return referenceCandidates.length ? referenceCandidates : allCandidates
}
